module.exports = "https://static.wanderu.com/static/media/booking-logo.2b9e0056.svg";